import { useTranslation } from 'i18n';
import { Typography } from 'ui';

import { guideImages } from '../../data';
import { GuideImage } from '../GuideImage/GuideImage';
import { GuideTitle } from '../GuideTitle/GuideTitle';

export const PartOne = ({ obfuscateAi }: { obfuscateAi: boolean }) => {
  const { t } = useTranslation('features');

  return (
    <>
      <GuideTitle obfuscateAi={obfuscateAi} />
      <GuideImage src={guideImages.makeAPile} alt={t('backlog.helpGuides.aiLoose.partOne.imageAlt')} height="fixed" />
      <Typography>
        <Typography component="span" fontWeight="bold">
          {t('backlog.helpGuides.aiLoose.partOne.makePile')}&nbsp;
        </Typography>
        {t('backlog.helpGuides.aiLoose.partOne.middleText')}&nbsp;
        <Typography component="span" fontWeight="bold">
          {t('backlog.helpGuides.aiLoose.partOne.takePhoto')}
        </Typography>
      </Typography>
    </>
  );
};
